var render = function render(){var _vm=this,_c=_vm._self._c;return _c('canvas',{ref:"canvas",staticClass:"canvas",class:{ active: _vm.active }})
}
var staticRenderFns = []

export { render, staticRenderFns }